
import React, { Suspense, useState, useEffect } from 'react';
import { Tabs, Tab, DataTableSkeleton } from 'carbon-components-react';
import {
    CheckmarkFilled20 as Resolved, InformationFilled20 as New, CloseFilled20 as Cancelled,
    StopFilled20 as Closed, WarningFilled20 as OnHold, PendingFilled20 as InProgress, NextFilled20 as InQueue, ErrorFilled20 as Rejected,
    RecordingFilled20 as Open, UserAvatarFilled20 as Assigned
} from '@carbon/icons-react';
import { Link } from "react-router-dom";
import { useLocation } from 'react-router';
import qs from 'query-string';
import moment from 'moment';

import * as resourceMockData from './ResourceIssuesMockData';
import ResourceIssuesTable from './ResourceIssuesTable';
import * as DashboardConstants from '../Dashboards/DashboardConstants';
import callPostApi from "../../requests/PostRequests";
import * as Constants from '../../requests/URLConstants';
import './ResourceIssues.scss';

export default function ResourceIssues(props) {
    const [loadedTabs, setLoadedTabs] = useState(['offline']);
    const [ResourceDataLoading, setResourceDataLoading] = useState(false);
    const [resourceStatusTab, setResourceStatusTab] = useState('offline');
    const [ResourceStatusData, setResourceStatusData] = useState([]);
    const [downloadResourceData, setDownloadResourceData] = useState([]);
    const location = useLocation();

    useEffect(() => {
        getResourceStatus(props.timeFilterSelections, resourceStatusTab, props.filterSelections);
    }, [props.timeFilterSelections, props.filterSelections]);

    const tabProps1 = {
        tabs: {
            selected: 0,
            type: 'container'
        },
        tab: {
            tabIndex: 0,
        },
    };

    const handleTabClick = (e) => {
        if (e && e.target && e.target.id && !loadedTabs.includes(e.target.id)) {
            setLoadedTabs([...loadedTabs, e.target.id]);
        }
        setResourceStatusTab(e.target.id === 'all' ? '' : e.target.id);

        getResourceStatus(props.timeFilterSelections, e.target.id === 'all' ? '' : e.target.id, props.filterSelections);
    };

    const getResourceStatus = (timeFilterSelections, resourceTab, filterSelections) => {
        setResourceDataLoading(true);
        let formattedData = [];
        let franchise;
        let client;
        let technology;
        if (filterSelections != null && filterSelections.franchise != null && filterSelections.franchise.length > 0) {
            franchise = filterSelections.franchise;

        }

        if (filterSelections != null && filterSelections.client != null && filterSelections.client.length > 0) {
            client = filterSelections.client;
        }
        if (filterSelections != null && filterSelections.technology != null && filterSelections.technology.length > 0) {
            technology = filterSelections.technology;
        }
        let bodyJSON = {
            filters: {
                time: {
                    startDateTime: timeFilterSelections.startDateTime,
                    endDateTime: timeFilterSelections.endDateTime
                },
                resourceStatusFilter: resourceTab,
                franchises: franchise,
                clients: client,
                technologies: technology
            }
        }
        callPostApi(Constants.GETRESOURCEISSUESSTATUS, {
            'Content-Type': 'application/json'
        }, bodyJSON)
            .then(resp => {
                formattedData = prepareResourceAlertsData(resp, resourceTab);
                setResourceStatusData(formattedData.tableData);
                setDownloadResourceData(formattedData.downloadArr);
                setResourceDataLoading(false);
            }).catch((error) => {
                setResourceDataLoading(false);
            });
    }

    function prepareIncidentStatus(incidentStatus) {
        if (incidentStatus !== null) {
            switch (incidentStatus) {
                case "New":
                    return <div className='img--status'><div><New /></div><div>{incidentStatus}</div></div>
                case "Cancelled":
                case "Canceled": //added both spellings for same case.
                    return <div className='img--status'><div><Cancelled /></div><div>{incidentStatus}</div></div>
                case "On Hold":
                    return <div className='img--status'><div><OnHold /></div><div>{incidentStatus}</div></div>
                case "In Progress":
                    return <div className='img--status'><div><InProgress /></div><div>{incidentStatus}</div></div>
                case "Resolved":
                    return <div className='img--status'><div><Resolved /></div><div>{incidentStatus}</div></div>
                case "Closed":
                    return <div className='img--status'><div><Closed /></div><div>{incidentStatus}</div></div>
                case "In Queue":
                    return <div className='img--status'><div><InQueue /></div><div>{incidentStatus}</div></div>
                case "Rejected":
                    return <div className='img--status'><div><Rejected /></div><div>{incidentStatus}</div></div>
                case "Open":
                    return <div className='img--status'><div><Open /></div><div>{incidentStatus}</div></div>
                case "Assigned":
                    return <div className='img--status'><div><Assigned /></div><div>{incidentStatus}</div></div>
                default:
                    return <div>{incidentStatus}</div>
            }
        }
        else return '';
    }

    function displayIncidentId(incidentId, sysId, client) {
        let path = '/IncidentDetails';
        /* Query Parameters */
        const queryParam = qs.parse(location.search);
        const newQueryParam = {
            ...queryParam,
            sysId: sysId,
            alertType: "Dependency failure",
            incidentId: incidentId,
            workspace: props.workspace,
            client: client
        }
        return (
            <div className="incident-link">
                <Link className="remove-underline"
                    to={
                        {
                            pathname: path, search: qs.stringify(newQueryParam)
                        }
                    }>
                    <div className="incident-id">{incidentId ? incidentId : '-'}</div>
                </Link>
            </div>
        )
    }

    const prepareResourceAlertsData = (response, resourceTab) => {
        let tableData = []; let respArr = [], downloadArr = [];
        let tableObj = {}, downloadObj = {};
        if (Object.keys(response).length > 0) {
            respArr.push(response);
            for (let i = 0; i < respArr.length; i++) {
                if (resourceTab === 'busy') {
                    for (let j = 0; j < respArr[i].busy.length; j++) {
                        let respObj = respArr[i].busy;
                        let offset = moment(respObj[j].lastStatusChanged).utcOffset();
                        tableObj = {
                            id: (j + 1).toString(),
                            resourceName: respObj[j].resourceName,
                            recentCurrentActiveProcess: respObj[j].recentCurrentActiveProcess,
                            timeSpaceSinceRecentExecution: respObj[j].timeSpaceSinceRecentExecution,
                            lastStatusChanged: moment.utc(respObj[j].lastStatusChanged).utcOffset(offset).format("YYYY-MM-DD HH:mm:ss"),
                            client: respObj[j].client,
                        }
                        tableData.push(tableObj);
                    }
                }
                else {
                    let respObj = ''; let resArr = [];
                    switch (resourceTab) {
                        case 'offline': respObj = respArr[i].offline
                            break;
                        case 'missing': respObj = respArr[i].missing
                            break;
                        case 'loggedOut': respObj = respArr[i].loggedOut
                            break;
                        case 'available': respObj = respArr[i].available
                            break;
                        case 'private': respObj = respArr[i].private
                            break;
                        case '':

                            for (let k = 0; k < respArr.length; k++) {
                                let respObj = '';
                                let keys = Object.keys(respArr[0]);
                                for (let l = 0; l < keys.length; l++) {
                                    switch (keys[l]) {
                                        case 'offline': respObj = respArr[k].offline
                                            break;
                                        case 'missing': respObj = respArr[k].missing
                                            break;
                                        case 'loggedOut': respObj = respArr[k].loggedOut
                                            break;
                                        case 'available': respObj = respArr[k].available
                                            break;
                                        case 'private': respObj = respArr[k].private
                                            break;
                                        case 'busy': respObj = respArr[k].busy
                                            break;
                                        case 'others': respObj = respArr[k].others
                                            break;
                                        default: respObj = [];
                                            break;
                                    }
                                    respObj.map((item) => {
                                        resArr.push(item);
                                    });
                                    console.log(resArr);
                                }
                            }
                            break;
                        default: break;
                    }
                    let array = resourceTab === '' ? resArr : respObj;
                    for (let j = 0; j < array.length; j++) {
                        let offset = moment(array[j].recentExecutionTime).utcOffset();
                        tableObj = {
                            id: (j + 1).toString(),
                            incidentNo: displayIncidentId(array[j].incidentNo, array[j].incidentSysId, array[j].partyName),
                            //displayIncidentId(array[j].incidentNo,array[j].incidentSysId,array[j].partyName),
                            assigned_to: array[j].assignedTo ? array[j].assignedTo : '',
                            incidentStatus: prepareIncidentStatus(array[j].incidentStatus),
                            resourceName: array[j].resourceName ? array[j].resourceName : '',
                            resourcePoolName: array[j].resourcePoolName ? array[j].resourcePoolName : '',
                            resourceStatus: array[j].resourceStatus ? array[j].resourceStatus : '',
                            recentCurrentActiveProcess: array[j].recentCurrentActiveProcess ? array[j].recentCurrentActiveProcess : '',
                            timeSpaceSinceRecentExecution: array[j].timeSpaceSinceRecentExecution ? array[j].timeSpaceSinceRecentExecution : '',
                            numberOfSimilarIssues: array[j].numberOfSimilarIssues ? array[j].numberOfSimilarIssues : '',
                            lastStatusChanged: array[j].recentExecutionTime ? moment.utc(array[j].recentExecutionTime).utcOffset(offset).format("YYYY-MM-DD HH:mm:ss") : '',
                            client: array[j].client ? array[j].client : '',
                        }
                        downloadObj = {
                            incidentNo: array[j].incidentNo,
                            assigned_to: array[j].assignedTo ? array[j].assignedTo : '',
                            incidentStatus: array[j].incidentStatus,
                            resourceName: array[j].resourceName ? array[j].resourceName : '',
                            resourcePoolName: array[j].resourcePoolName ? array[j].resourcePoolName : '',
                            resourceStatus: array[j].resourceStatus ? array[j].resourceStatus : '',
                            recentCurrentActiveProcess: array[j].recentCurrentActiveProcess ? array[j].recentCurrentActiveProcess : '',
                            timeSpaceSinceRecentExecution: array[j].timeSpaceSinceRecentExecution ? array[j].timeSpaceSinceRecentExecution : '',
                            numberOfSimilarIssues: array[j].numberOfSimilarIssues ? array[j].numberOfSimilarIssues : '',
                            lastStatusChanged: array[j].recentExecutionTime ? moment.utc(array[j].recentExecutionTime).utcOffset(offset).format("YYYY-MM-DD HH:mm:ss") : '',
                            client: array[j].client ? array[j].client : '',
                        }

                        tableData.push(tableObj);
                        downloadArr.push(downloadObj);

                    }
                }
            }
        }
        tableData.sort((a, b) => (new Date(b.lastStatusChanged).getTime() || -Infinity) - (new Date(a.lastStatusChanged).getTime() || -Infinity));
        return { tableData, downloadArr };
    };

    return (
        <div className="manage-automation-page__r3">
            <div className="bx--col">
                <p className='padding-top manage-automation-page__subheading carbon-display-Regular-20'>{DashboardConstants.ResourceStatus}</p>
            </div>
            <div className="manage-automation-page-alerts Resource-issues">
                <Tabs
                    {...tabProps1.tabs}
                    bx--grid--full-width
                    aria-label="Tab navigation">
                    <Tab {...tabProps1.tab} id='offline' bx--grid--full-width label={DashboardConstants.Offline} onClick={handleTabClick}>
                        <Suspense fallback={<div></div>}>
                            {ResourceDataLoading ?
                                <div>
                                    <DataTableSkeleton
                                        columnCount={resourceMockData.OfflineHeaders.length}
                                        rowCount={10}
                                        headers={resourceMockData.OfflineHeaders}
                                    />
                                </div> :
                                <ResourceIssuesTable
                                    headers={resourceMockData.OfflineHeaders}
                                    loading={ResourceDataLoading}
                                    rows={ResourceStatusData}
                                    downloadRows={downloadResourceData}
                                    title={DashboardConstants.Offline}
                                    status='offline'
                                    filterData={props.filterData}
                                    filterSelections={props.filterSelections}
                                    disabledSelects={props.disabledSelects}
                                    updateState={props.updateState}
                                    alertType='reactive'
                                    workspace={props.workspace}
                                    isResourceType={true}
                                />}
                        </Suspense>
                    </Tab>
                    <Tab {...tabProps1.tab} id='missing' label={DashboardConstants.Missing} onClick={handleTabClick}>
                        {loadedTabs.includes('missing') ?
                            <Suspense fallback={<div></div>}>
                                {ResourceDataLoading ?
                                    <div>
                                        <DataTableSkeleton
                                            columnCount={resourceMockData.OfflineHeaders.length}
                                            rowCount={10}
                                            headers={resourceMockData.OfflineHeaders}
                                        />
                                    </div> :
                                    <ResourceIssuesTable
                                        headers={resourceMockData.OfflineHeaders}
                                        loading={ResourceDataLoading}
                                        rows={ResourceStatusData}
                                        downloadRows={downloadResourceData}
                                        title={DashboardConstants.Missing}
                                        status='missing'
                                        filterData={props.filterData}
                                        filterSelections={props.filterSelections}
                                        disabledSelects={props.disabledSelects}
                                        updateState={props.updateState}
                                        alertType='reactive'
                                        workspace={props.workspace}
                                        isResourceType={true}
                                    />}
                            </Suspense>
                            : null}
                    </Tab>
                    <Tab {...tabProps1.tab} id='loggedOut' label={DashboardConstants.LoggedOut} onClick={handleTabClick}>
                        {loadedTabs.includes('loggedOut') ?
                            <Suspense fallback={<div></div>}>
                                {ResourceDataLoading ?
                                    <div>
                                        <DataTableSkeleton
                                            columnCount={resourceMockData.OfflineHeaders.length}
                                            rowCount={10}
                                            headers={resourceMockData.OfflineHeaders}
                                        />
                                    </div> :
                                    <ResourceIssuesTable
                                        headers={resourceMockData.OfflineHeaders}
                                        loading={ResourceDataLoading}
                                        rows={ResourceStatusData}
                                        downloadRows={downloadResourceData}
                                        title={DashboardConstants.LoggedOut}
                                        status='loggedOut'
                                        filterData={props.filterData}
                                        filterSelections={props.filterSelections}
                                        disabledSelects={props.disabledSelects}
                                        updateState={props.updateState}
                                        alertType='reactive'
                                        workspace={props.workspace}
                                        isResourceType={true}
                                    />}
                            </Suspense>
                            : null}
                    </Tab>
                    <Tab {...tabProps1.tab} id='available' label={DashboardConstants.Available} onClick={handleTabClick}>
                        {loadedTabs.includes('available') ?
                            <Suspense fallback={<div></div>}>
                                {ResourceDataLoading ?
                                    <div>
                                        <DataTableSkeleton
                                            columnCount={resourceMockData.busyHeaders}
                                            rowCount={10}
                                            headers={resourceMockData.busyHeaders}
                                        />
                                    </div> :
                                    <ResourceIssuesTable
                                        headers={resourceMockData.OfflineHeaders}
                                        loading={ResourceDataLoading}
                                        rows={ResourceStatusData}
                                        downloadRows={downloadResourceData}
                                        title={DashboardConstants.Available}
                                        status='available'
                                        filterData={props.filterData}
                                        filterSelections={props.filterSelections}
                                        disabledSelects={props.disabledSelects}
                                        updateState={props.updateState}
                                        alertType='reactive'
                                        workspace={props.workspace}
                                        isResourceType={true}
                                    />}
                            </Suspense>
                            : null}
                    </Tab>
                    <Tab {...tabProps1.tab} id='busy' label={DashboardConstants.Busy} onClick={handleTabClick}>
                        {loadedTabs.includes('busy') ?
                            <Suspense fallback={<div></div>}>
                                {ResourceDataLoading ?
                                    <div>
                                        <DataTableSkeleton
                                            columnCount={resourceMockData.OfflineHeaders.length}
                                            rowCount={10}
                                            headers={resourceMockData.OfflineHeaders}
                                        />
                                    </div> :
                                    <ResourceIssuesTable
                                        headers={resourceMockData.busyHeaders}
                                        loading={ResourceDataLoading}
                                        rows={ResourceStatusData}
                                        downloadRows={downloadResourceData}
                                        title={DashboardConstants.Busy}
                                        status='busy'
                                        filterData={props.filterData}
                                        filterSelections={props.filterSelections}
                                        disabledSelects={props.disabledSelects}
                                        updateState={props.updateState}
                                        alertType='reactive'
                                        workspace={props.workspace}
                                        isResourceType={true}
                                    />}
                            </Suspense>
                            : null}
                    </Tab>
                    <Tab {...tabProps1.tab} id='private' label={DashboardConstants.Private} onClick={handleTabClick}>
                        {loadedTabs.includes('private') ?
                            <Suspense fallback={<div></div>}>
                                {ResourceDataLoading ?
                                    <div>
                                        <DataTableSkeleton
                                            columnCount={resourceMockData.OfflineHeaders.length}
                                            rowCount={10}
                                            headers={resourceMockData.OfflineHeaders}
                                        />
                                    </div> :
                                    <ResourceIssuesTable
                                        headers={resourceMockData.OfflineHeaders}
                                        loading={ResourceDataLoading}
                                        rows={ResourceStatusData}
                                        downloadRows={downloadResourceData}
                                        title={DashboardConstants.Private}
                                        status='private'
                                        filterData={props.filterData}
                                        filterSelections={props.filterSelections}
                                        disabledSelects={props.disabledSelects}
                                        updateState={props.updateState}
                                        alertType='reactive'
                                        workspace={props.workspace}
                                        isResourceType={true}
                                    />}
                            </Suspense>
                            : null}
                    </Tab>
                    <Tab {...tabProps1.tab} id='all' label={DashboardConstants.All} onClick={handleTabClick}>
                        {loadedTabs.includes('all') ?
                            <Suspense fallback={<div></div>}>
                                {ResourceDataLoading ?
                                    <div>
                                        <DataTableSkeleton
                                            columnCount={resourceMockData.OfflineHeaders.length}
                                            rowCount={10}
                                            headers={resourceMockData.OfflineHeaders}
                                        />
                                    </div> :
                                    <ResourceIssuesTable
                                        headers={resourceMockData.OfflineHeaders}
                                        loading={ResourceDataLoading}
                                        rows={ResourceStatusData}
                                        downloadRows={downloadResourceData}
                                        title={DashboardConstants.All}
                                        status='all'
                                        filterData={props.filterData}
                                        filterSelections={props.filterSelections}
                                        disabledSelects={props.disabledSelects}
                                        updateState={props.updateState}
                                        alertType='reactive'
                                        workspace={props.workspace}
                                        isResourceType={true}
                                    />}
                            </Suspense>
                            : null}
                    </Tab>
                </Tabs>
            </div>
        </div>
    )
}
